import React, { Component } from 'react';
import { injectIntl, intlShape } from 'react-intl';
import { FormattedTag } from 'core/components';
import { getStaticUrl } from 'core/helpers';
import { Main } from 'components/main/main';
import { Carousel } from 'components/carousel/carousel';
import { HeadHelmet } from 'components/head-helmet/head-helmet';
import { VipItemCard } from 'components/vip/vip-item-card';
import { VipTable } from 'components/vip/vip-table';
import { PAGE_NAMES } from '../../constants';

import './vip.scss';

const carouselSettings = {
  arrows: true,
  dots: true,
  responsive: [
    {
      breakpoint: 719,
      settings: {
        arrows: false,
        slidesToShow: 1.05,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 1024,
      settings: {
        arrows: false,
        slidesToShow: 2.35,
        slidesToScroll: 1,
      },
    },
  ],
};

const staticUrl = getStaticUrl();

class VipUI extends Component {
  static propTypes = {
    intl: intlShape.isRequired
  }

  getLevels = () => {
    const { intl } = this.props;

    const itemLevel1 = JSON.parse(`{${intl.formatMessage({ id: 'vip.level.1.data' }, { currency: 'THB' })}}`);
    const itemLevel2 = JSON.parse(`{${intl.formatMessage({ id: 'vip.level.2.data' }, { currency: 'THB' })}}`);
    const itemLevel3 = JSON.parse(`{${intl.formatMessage({ id: 'vip.level.3.data' }, { currency: 'THB' })}}`);
    const itemLevel4 = JSON.parse(`{${intl.formatMessage({ id: 'vip.level.4.data' }, { currency: 'THB' })}}`);
    const itemLevel5 = JSON.parse(`{${intl.formatMessage({ id: 'vip.level.5.data' }, { currency: 'THB' })}}`);

    const levels = [
      itemLevel1,
      itemLevel2,
      itemLevel3,
      itemLevel4,
      itemLevel5
    ];

    return levels;
  }

  render() {
    return (
      <Main className="vip-page">
        <HeadHelmet
          page={PAGE_NAMES.VIP}
          options={{ indexing: false }}
        />

        <div className="vip-page-bg" />

        <div className="text-center mt-md-5">
          <FormattedTag tag="h1" id="vip.main" className="font-weight-strong text-capitalize mt-4_75 mt-md-8_5 mb-1_25 letter-spacing-default title-main" />
          <FormattedTag id="vip.secondary" className="text-gray-20 title-secondary mx-auto letter-spacing-default mt-md-2_25" />

          <div className="d-flex flex-column flex-md-row-reverse align-items-center">
            <img className="img-account-manager ml-5_5 ml-md-12 mt-0_75 mt-md-2_25" src={`${staticUrl}/vip/account-manager.png`} alt="account-manager-icon" />

            <FormattedTag id="vip.manager" className="h2 text-capitalize letter-spacing-extra my-1 d-md-none" />

            <div className="d-md-flex flex-column align-items-end mt-md-8_5">
              <FormattedTag id="vip.manager" className="h2 text-capitalize letter-spacing-default mb-1_5 mt-1 d-none d-md-block" />
              <FormattedTag id="vip.manager.desc" className="text-gray-20 mx-auto mx-md-0 title-secondary-desc letter-spacing-default text-md-right" />
            </div>
          </div>

          <div className="d-flex flex-column align-items-center flex-md-row">
            <img className="img-higher-limits mt-3_25 mt-md-2 ml-md-8" src={`${staticUrl}/vip/higher-limits.png`} alt="higher-limits-icon" />

            <FormattedTag id="vip.limits" className="h2 text-capitalize letter-spacing-extra my-1 d-md-none" />

            <div className="d-md-flex flex-column align-items-start ml-md-8 mt-md-2_25">
              <FormattedTag id="vip.limits" className="h2 text-capitalize letter-spacing-default mb-1_5 mt-1 d-none d-md-block" />
              <FormattedTag id="vip.limits.desc" className="text-gray-20 mx-auto mx-md-0 text-md-left title-secondary-desc letter-spacing-default" />
            </div>
          </div>

          <div className="d-flex flex-column align-items-center flex-md-row-reverse">
            <img className="img-exclusive-promotions mb-0_5 mt-3_25 mt-md-3 mr-md-1" src={`${staticUrl}/vip/exclusive-promotions.png`} alt="exclusive-promotions-icon" />

            <FormattedTag id="vip.promo" className="h2 text-capitalize letter-spacing-extra my-1 d-md-none" />

            <div className="d-md-flex flex-column align-items-end mr-md-4 mt-md-1_5">
              <FormattedTag id="vip.promo" className="h2 text-capitalize letter-spacing-default mb-1_25 mt-1 d-none d-md-block" />
              <FormattedTag id="vip.promo.desc" className="text-gray-20 mx-auto mx-md-0 text-md-right title-secondary-desc letter-spacing-default" />
            </div>
          </div>

          <Carousel className="vip-items-carousel mt-5 d-md-none mr-n2 mr-sm-0" settings={carouselSettings}>
            {this.getLevels().map((item, idx) => (
              <VipItemCard key={item.xp} level={item} sortIndex={idx + 1} />
            ))}
          </Carousel>
          <div className="table-desktop-container d-none d-md-block rounded overflow-hidden border border-gray-0 mt-md-8_5">
            <VipTable levels={this.getLevels()} />
          </div>

        </div>
      </Main>
    );
  }
}

export default injectIntl(VipUI);
